import React, { Component } from "react";
import styled from "styled-components";
import { history } from "../../utils";
import { Flex, Link, Button } from "../../components";
import Gamification from '../../components/Gamification';
const TestDescriptionWrapper = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 2rem;
  margin-bottom: 6rem;
  img {
    width: 100%;
  }
  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;



function checkNative() {
  try {
    if ((window.webkit) || window.appInterface)
      return true;
    else return false;
  } catch (error) {
    console.log(error);
  }
}

class TestDescription extends Component {

  state = {
    showGamificaton: false,
    numbers: [1, 2, 3],
    currentNumber: 1
  }
  startTest = (results, search) => {
    this.setState({ showGamificaton: true })
    setTimeout(() => {
      this.setState({ showGamificaton: false })
      if (results) {
        history.push(`practiceTestResults/0${search}`)
      } else {
        history.push(`/practiceTest/0${search}`)
      }
    }, 4200)

  }

  componentDidMount = () => {
    window.removeEventListener('beforeunload', null)
  }
  callbackToNative = (msg) => {
    try {
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.observe.postMessage(msg);
        window.webkit.messageHandlers.appInterface.postMessage(msg)
      }
      if (window.appInterface != undefined) {
        window.appInterface.postMessage(msg)
      }
      console.log('calling back')
    } catch (error) {
      console.log(msg);
      console(error);
    }
  }
  render() {
    let { search, practice_name, test_img, timelimit, description, results } = this.props;
    console.log(this.props)
    let queryParams = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/==/g, '').replace(/=/g,
      '":"') + '"}')
    if (queryParams && queryParams.practice_id) {
      if (!practice_name) {
        return <div style={{ padding: '20px' }}>
          <div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: '50px', cursor: 'pointer', margin: 'auto', marginLeft: '10px' }}>
                <img onClick={() => this.callbackToNative('done')} src="/images/back.svg"></img>
              </div>
              <h3 style={{ marginTop: '100px' }}>Test has been already submitted</h3>
            </div>
          </div>
        </div>
      }
    }
    if (this.state.showGamificaton) {
      return <Gamification></Gamification>
    }
    return (
      <div style={{ padding: '20px' }}>
        <div>
          {practice_name ?

            <Flex column center>
              <div style={{ position: 'fixed', top: '0', paddingTop: '20px', left: '20px', background: '#f6f6f6', width: '100%', cursor: 'pointer' }}>
                <img onClick={() => this.callbackToNative('done')} src="/images/back.svg"></img>
              </div>
              <h1 style={{ margin: '0.3em 0', marginTop: '30px', fontSize: '28px' }}>{practice_name}</h1>
              <TestDescriptionWrapper>
                {test_img &&
                  <img
                    src={test_img}
                    alt=""
                  />
                }
                <Flex column>
                  <div>
                    <h3 style={{ fontSize: '20px', margin: '0.3em 0' }}>Instructions:</h3>
                    <ul>
                      <li>
                        <b>Make sure that you don’t switch the app. Switching more than twice submits the test.</b>
                      </li>
                      <li>
                        <b>Please put your phone in Do-Not-Disturb (DND) mode while taking the test.</b>
                      </li>
                      <li>
                        The time spent on the test will be indicated on the top.
                      </li>
                      <li>
                        The test will be Multiple choice questions with a single correct answer.
                      </li>
                      <li>
                        There is no negative marking for the incorrectly answered questions
                      </li>
                      <li>
                        One point will be awarded for each correctly answered question.
                      </li>
                      <li>
                        There will be four level of questions: Remembering, Understanding, Applying and Analyzing.
                      </li>
                      <li style={{ fontWeight: 'bold' }}>
                        The result for each question will appear once you select an option.</li>
                      <li>
                        The detailed report for the test will be displayed at the end of the test.</li>

                    </ul>
                  </div>
                </Flex>
              </TestDescriptionWrapper>
              <Flex direction="row" justifyBetween alignCenter style={{ position: 'fixed', bottom: '0', background: '#f6f6f6', padding: '0 20%', paddingBottom: '10px', overflowY: 'hidden' }}>
                {/* <Link to={results ? `practiceTestResults/0${search}` : `/practiceTest/0${search}`}> */}
                <div>
                  <button className='startButton' onClick={() => this.startTest(results, search)} style={{ fontSize: '16px' }} small>{results ? `Show answers` : `START TEST`}</button>
                  {/* </Link> */}
                </div>
              </Flex>
            </Flex>
            : <div style={{ textAlign: 'center' }}>
              <div style={{ width: '50px', cursor: 'pointer', margin: 'auto', marginLeft: '10px' }}>
                <img onClick={() => this.callbackToNative('done')} src="/images/back.svg"></img>
              </div>
              <h3 style={{ marginTop: '100px' }}>We are working on new questions. See you shortly!</h3>
            </div>}
        </div>
        <style jsx='true' scoped>{`
      .startButton{
          padding: 0.5em 2.5em;
          font-size: 16px;
          font-weight: bold;
          border-radius: 16px;
          background: 
            linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
            linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
          color: white;
          border: none;
          cursor: pointer;
          &:focus{
            outline:0;
          }
      }
     
     `}

        </style>
      </div>
    )
  }
}
export default TestDescription;
